<template>
  <div></div>
</template>
<script>
export default {
  mounted() {
    this.$emit("mount");
  },
  beforeDestroy() {
    this.$emit("unmount");
  }
}
</script>
